module.exports = __webpack_public_path__ + "img/build3.8ac881ff.png";